import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import './assets/scss/main.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { I18nextProvider } from 'react-i18next';
import i18n from "./i18n/index";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <QueryClientProvider client={queryClient}>
            <App />
            <ToastContainer
              theme="colored"
              position="bottom-left"
              autoClose={3000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              closeButton={false}
              rtl={true}
              toastClassName="shadow-md rounded w-75"
              limit={2}
            />
          </QueryClientProvider>
        </Router>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
